let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("4Dj77")]).then(() => parcelRequire('1Ve5d'));